export const VARIANT_BUTTON_WIDTH = '124px';
export const VARIANT_BUTTON_HEIGHT = '48px';
